import { getPriceAsCurrency } from '@lib/utils';

export type StripeInvoiceLine = {
  amount: number;
  description: string;
  currency: string;
};

type InvoiceTableType = {
  term: string;
  newSubscriptionPrice: string;
  invoiceLines: StripeInvoiceLine[];
  invoiceTotal: number | undefined;
  hasCreditBalance: boolean;
  currencySymbol: string;
};

const InvoiceTable = ({
  term,
  newSubscriptionPrice,
  invoiceLines,
  invoiceTotal,
  hasCreditBalance,
  currencySymbol
}: InvoiceTableType) => {
  const detailedInvoiceLines = invoiceLines.filter(
    (line) => line.description !== null
  );
  return (
    <div className="mt-6 space-y-2 mb-6">
      <h3>{'Invoice Preview'}</h3>
      <table className="border-separate border-spacing-y-4">
        <tbody>
          {!detailedInvoiceLines && (
            <tr>
              <td className="mr-2">{`New subscription cost per ${term?.toLocaleLowerCase()}:`}</td>
              <td className="pl-4">
                {' '}
                {currencySymbol}
                {newSubscriptionPrice}
              </td>
            </tr>
          )}
          {detailedInvoiceLines.map((line: StripeInvoiceLine, index) => {
            return (
              <tr
                key={`invoice-line-${index}`}
                data-cy={`invoice-line-${index}`}
              >
                <td className="mr-2 max-w-xs text-xs md:text-sm">
                  {line?.description}
                </td>
                <td className="pl-4">
                  {currencySymbol}
                  {line?.amount / 100}
                </td>
              </tr>
            );
          })}
          <tr className="mt-4">
            <td className="font-semibold">Cost of changing plan:</td>
            <td className="font-semibold pl-4">
              {' '}
              {getPriceAsCurrency(invoiceTotal, currencySymbol)}
            </td>
          </tr>
          {hasCreditBalance && (
            <tr className="mt-6">
              <td className="text-xs">
                Credit balance will be applied to future invoices
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default InvoiceTable;
